/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { PreventiveSheetAttachmentService } from './PreventiveSheetAttachmentService';

class PreventiveSheetAttachmentServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new PreventiveSheetAttachmentService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { PreventiveSheetAttachmentServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/service/PreventiveSheetAttachmentServiceProvider.js